const IMPORTED_USERS = 'IMPORTED_USERS';

export default IMPORTED_USERS;
